import React, {memo, useMemo} from 'react'
import {Space} from 'antd'
import {VStack} from '../../../../../ui/Stack'
import {useFormatDate} from '../../../activity-timeline/hooks/useFormatDate'
import dayjs from 'dayjs'

export type Status = 'wait' | 'process' | 'finish' | 'error'
export interface StagePlanItemI {
  name?: string,
  code?: string,
  status?: Status,
  date_start?: string,
  date_end?: string,
  responsible?: string
}
export const StagePlanItem: React.FC<StagePlanItemI> = memo((props: StagePlanItemI) => {
  const {date_end, date_start, name} = props

  const formatDateStart = useMemo<null | string>(
    () => date_start ? dayjs(date_start).format('DD.MM.YYYY') : null,
    [date_start],
  )

  const formatDateEnd = useMemo<null | string>(
    () => date_end ? dayjs(date_end).format('DD.MM.YYYY') : null,
    [date_end],
  )

  return (
    <VStack align={"start"} style={{paddingBottom: '16px'}}>
      <Space size={4}>
        <span style={{fontWeight: 'bold'}}>
          {name}{formatDateEnd && `, ${formatDateEnd}`}
        </span>
      </Space>
      {formatDateStart && <Space size={4}>
		  <span>Дата (начала):</span> {formatDateStart}
	  </Space>}
    </VStack>
  )
})
